import type { QueryClient } from '@tanstack/react-query';

// S1 Phase 11B (R2 #1) — 사업팀이 고객사 진행 상태를 바꾸면 그 변화가 계약 /
// 인프라 발주 / 배정 / 대시보드 등 다른 팀 화면에도 즉시 반영돼야 한다. 상태는
// synthesizeStatus 로 여러 entity 에서 합성되므로, 한 곳의 mutation 이 끝나면
// 연관 query 도메인을 일괄 invalidate 해 stale 캐시로 인한 "다른 탭에 반영 안 됨"
// 버그를 막는다.
//
// queryKey 의 첫 segment 만 매칭하면 TanStack Query 가 해당 prefix 로 시작하는
// 모든 query 를 무효화한다 (예: ['customer-master', filters] 와
// ['customer-master', 'one', id] 둘 다).
const CASCADE_KEYS = [
  'customer-master',
  'customers',
  'contracts',
  // round4 #5a (BUG#6) — Deal 도 합성 상태/견적 카드의 소스라 cascade 에 포함.
  'deals',
  'deployments',
  'assignments',
  'infrastructure-orders',
  'dashboard',
] as const;

export function invalidateCustomerMasterCascade(qc: QueryClient): void {
  for (const key of CASCADE_KEYS) {
    qc.invalidateQueries({ queryKey: [key] });
  }
}
